
<template>
  <div class="attachment-div">
    <video
      ref="videoplayer"
      width="320"
      height="240"
      :controls="true"
      :autoplay="false"
    >
      <source :src="attachmentSrc" type="video/mp4" />
      <!--Suportado em IE9, Chrome 6 e Safari 5 -->
      O seu navegador não suporta a tag vídeo
    </video>
    <div class="mt-2 attachment-discard-div">
      <a v-if="discardVisible" href="#" @click.prevent="discard">
        <label class="link">
          {{ $t("geral.discard") }}
        </label>
      </a>
    </div>
    <div class="textAttachment" v-if="attachmentNumber != null">
      Anexo {{ attachmentNumber }}
    </div>

    <!-- {{attachments}} -->
    <!-- {{attachmentSrc}} -->
    <!-- <div>attachmentSrc: {{attachmentSrc}}</div> -->
    <!-- <div>attachmentId: {{attachmentId}}</div> -->
    <!-- <div>attachmentName: {{attachmentName}}</div> -->
  </div>
</template>
    
  <script>
import "viewerjs/dist/viewer.css";
import Viewer from "v-viewer";
import Vue from "vue";
import axios from "axios";

Vue.use(Viewer);

export default {
  name: "AuthedVideo",
  props: {
    attachmentSrc: String,
    attachmentUrl: String,
    attachmentId: String,
    attachmentName: String,
    attachmentNumber: Number,
    discardVisible: Boolean,
    token: {
      description: "Token de acesso",
      type: String,
      required: true,
    },
  },
  data: function () {
    return {};
  },
  created() {
    if (this.isSrcEmpty) {
      this.getImage();
    }
  },
  computed: {
    isSrcEmpty() {
      if (!this.attachmentSrc) return true;
      if (this.attachmentSrc == null) return true;
      if (this.attachmentSrc == "") return true;
      return false;
    },
  },
  methods: {
    discard() {
      this.$emit("discard", this.attachmentId);
    },
    displayVideo(videoFile, videoEl) {
      // Preconditions:
      if (!(videoFile instanceof Blob))
        throw new Error("`videoFile` must be a Blob or File object."); // The `File` prototype extends the `Blob` prototype, so `instanceof Blob` works for both.
      if (!(videoEl instanceof HTMLVideoElement))
        throw new Error("`videoEl` must be a <video> element.");

      const newObjectUrl = URL.createObjectURL(videoFile);

      // URLs created by `URL.createObjectURL` always use the `blob:` URI scheme: https://w3c.github.io/FileAPI/#dfn-createObjectURL
      const oldObjectUrl = videoEl.currentSrc;
      if (oldObjectUrl && oldObjectUrl.startsWith("blob:")) {
        // It is very important to revoke the previous ObjectURL to prevent memory leaks. Un-set the `src` first.
        // See https://developer.mozilla.org/en-US/docs/Web/API/URL/createObjectURL

        videoEl.src = ""; // <-- Un-set the src property *before* revoking the object URL.
        URL.revokeObjectURL(oldObjectUrl);
      }

      // Then set the new URL:
      videoEl.src = newObjectUrl;

      // And load it:
      // videoEl.load(); // https://developer.mozilla.org/en-US/docs/Web/API/HTMLMediaElement/load
    },
    async getImage() {
      try {
        const response = await axios.request({
          url: this.attachmentUrl,
          method: "GET",
          responseType: "blob",
          headers: {
            "Content-Type": "video/mp4",
            Authorization: `Bearer ${this.token}`,
          },
        });
        this.displayVideo(response.data, this.$refs["videoplayer"]);
      } catch (error) {
        console.log(error);
        if (error.response) {
          console.log(error.response);
          if (error.response.data) {
            console.log(error.response.data.errors);
            if (error.response.status == 400) {
              console.log(error.response.data.errors);
            }
          }
        }
      }
    },
  },
};
</script>
    
  <style scoped>
.attachment-div {
  border: 1px;
  border-color: #2b3553;
  border-radius: 0.4285rem;
  border-style: solid;
  padding-left: 20px;
  padding-right: 20px;
  padding-top: 20px;
  margin-top: 10px;
  margin-bottom: 15px;
  text-align: center;
}
.attachment-discard-div {
  text-align: center;
}
.attachment-img-div {
  align-items: center !important;
  /* display: flex; */
  max-width: 100%;
  max-height: 100%;
  height: 150px;
}
.textAttachment {
  text-align: center !important;
}
.link {
  cursor: pointer;
}
.link:hover {
  color: white !important;
}
</style>